export default __webpack_public_path__ + "static/media/diadem-premier-clay-court.f2873a9d.jpg";